import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  TextField,
  Typography,
  Button,
  FormLabel,
  Toolbar,
  Chip
} from "@material-ui/core";
import { Tabs, Tab } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import { FormGroup, FormControl } from "@material-ui/core";
import TabContainer from "./shares/react_tab_container";
import language from "../layout/language";

import Select from "@material-ui/core/Select";
import ImageControl from "./shares/react_image_control";
import $ from "jquery";

// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/third_party/font_awesome.min.js";
import "froala-editor/js/third_party/ionicons.min.js";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

// Require Font Awesome.
import "froala-editor/css/third_party/font_awesome.min.css";
import "froala-editor/css/third_party/ionicons.min.css";

import FroalaEditor from "react-froala-wysiwyg";

import classNames from "classnames";
import Utils from "../api/api";
import theme, { styles } from "../layout/theme";

class BlogDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      tags: [],
      status: ['Draft','Publish','UnPublish'],
      blog: {
        author: "",
        date: new Date().toString(),
        urlVN: "",
        urlEN: "",
        thumb: "",
        titleVN: "",
        subtitleVN: "",
        titleEN: "",
        subtitleEN: "",
        summaryVN: "",
        detailVN: "",
        summaryEN: "",
        detailEN: "",
        descriptionVN: "",
        descriptionEN: "",
        category: "",
        tags: [],
        status: 0
      },
      error: {
        vn: false,
        en: false,
        titleVN_error: false,
        summaryVN_error: false,
        detailVN_error: false,
        titleEN_error: false,
        summaryEN_error: false,
        detailEN_error: false
      },
      failed: false,
      message: "",
      isUpdate: false,
      tab: 0,
      open: false,
      options: {'empty':'empty'}
    };
  }
  componentDidMount() {
    //console.log(this.props.action)
    var $this = this;
    var params = this.context.router.route.match.params;

    Utils.getListData("blog_category", 'all', 100, "0,0", null, 1, function(data) {
      //console.log(data);
      if (data.status == "success") {
        $this.setState({ categories: data.results });
      }
    });

    Utils.getListData("tags",'all', 1000, "0,0", null, 1, function(data) {
      //console.log(data);
      if (data.status === "success") {
        $this.setState({ tags: data.results });
      }
    });

    Utils.getBlockContents((options) => {
      $this.setState({options:options});
    });

    if (params.id !== undefined) {
      $this.setState(
        {
          isUpdate: true
        },
        function() {
          Utils.getSingleData("blogs", params.id, function(res) {
            if (res.status === "success" && res.results !== undefined) {
              var data = {},
                item = res.results;
              for (var property in item) {
                if (item.hasOwnProperty(property)) {
                  data[property] = item[property];
                }
              }
              data._id = item._id;
              if (data.urlVN === undefined) data.urlVN = '';
              if (data.urlEN === undefined) data.urlEN = '';
              if (data.tags === undefined) data.tags = [];
              if (data.category === undefined || data.category === null)
                data.category = "";
              $this.setState({ blog: data });
            }
          });
        }
      );
    }
  }
  onEditorStateChange(field, value) {
    var blog = this.state.blog,
      error = this.state.error;
    blog[field] = value;
    error[field + "_error"] = value === "";

    if (field.indexOf("summary") !== -1) {
      var locale = field.replace("summary", "");
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = value;
      // Retrieve the text property of the element (cross-browser support)
      var text =
        temporalDivElement.textContent || temporalDivElement.innerText || "";
      blog["description" + locale] = text.substring(0, 200);
    }

    this.setState({ blog: blog, error: error });
  }
  handleImageChange(value) {
    var blog = this.state.blog;
    blog.thumb = value;
    this.setState({ blog: blog });
  }
  handleFieldChange(e) {
    var blog = this.state.blog;
    blog[e.target.id] = e.target.value;
    if (e.target.type == "textarea") {
      blog[e.target.id] = e.target.value.substring(0, 200);
    }
    this.setState({ blog: blog });
  }
  handleValidate(e, flag) {
    var $this = this,
      blog = this.state.blog,
      obj = this.state.error;

    blog[e.target.id] = e.target.value;

    var p = e.target.id + "_error";

    if (e.target.value.trim() === "" || e.target.value === null) {
      obj[p] = true;
    } else {
      obj[p] = false;
    }
    obj[flag] = false;

    if (e.target.id === "titleVN") {
      var urlVN = Utils.getFriendlyURL(e.target.value.trim());
      blog.urlVN = urlVN;
    }
    if (e.target.id === "titleEN") {
      var urlEN = Utils.getFriendlyURL(e.target.value.trim());
      blog.urlEN = urlEN;
    }

    this.setState({ blog: blog, error: obj }, () => {
      if (
        !$this.state.error.titleVN_error &&
        !$this.state.error.summaryVN_error &&
        !$this.state.error.detailVN_error
      ) {
        obj["vn"] = false;
      } else {
        obj["vn"] = true;
      }
      if (
        !$this.state.error.titleEN_error &&
        !$this.state.error.summaryEN_error &&
        !$this.state.error.detailEN_error
      ) {
        obj["en"] = false;
      } else {
        obj["en"] = true;
      }
      // if(!$this.state.error.titleKR_error && !$this.state.error.summaryKR_error && !$this.state.error.detailKR_error){
      //   obj['kr'] = false;
      // }else{
      //   obj['kr'] = true;
      // }
      $this.setState({ error: obj });
    });
  }
  _save() {
    var $this = this;
    var data = this.state.blog;

    data.status = parseInt(data.status);

    if (this.state.isUpdate) {
      //data._id = this.state.id;
      Utils._update("blog", data, function(res) {
        //console.log(res);
        if (res.status === "success") {
          $this.context.router.history.push("/blog/");
        } else {
          $this.setState({
            failed: true,
            message: JSON.stringify(res.message)
          });
        }
      });
    } else {
      Utils._add("blog", data, function(res) {
        if (res.status == "success") {
          $this.context.router.history.push("/blog/");
        } else {
          $this.setState({
            failed: true,
            message: JSON.stringify(res.message)
          });
        }
      });
    }
  }
  handleSave(e, flag) {
    var params = this.context.router.route.match.params;

    if (params.id !== undefined && !this.state.isUpdate) {
      this.setState({ isUpdate: true });
    }
    var $this = this;
    var obj = this.state.error;
    if (obj[flag]) {
      return;
    } else {
      switch (flag) {
        case "vn":
          obj["titleVN_error"] = this.state.blog.titleVN === "";
          obj["summaryVN_error"] = this.state.blog.summaryVN === "";
          obj["detailVN_error"] = this.state.blog.detailVN === "";
          obj["vn"] =
            obj["titleVN_error"] ||
            obj["summaryVN_error"] ||
            obj["detailVN_error"];
          this.setState({ error: obj }, function() {
            if (!$this.state.error[flag]) $this._save();
          });
          break;
        case "en":
          obj["titleEN_error"] = this.state.blog.titleEN === "";
          obj["summaryEN_error"] = this.state.blog.summaryEN === "";
          obj["detailEN_error"] = this.state.blog.detailEN === "";
          obj["en"] =
            obj["titleEN_error"] ||
            obj["summaryEN_error"] ||
            obj["detailEN_error"];
          this.setState({ error: obj }, function() {
            if (!$this.state.error[flag]) $this._save();
          });
          break;
        // case 'kr':
        //   obj['titleKR_error'] = this.state.blog.titleKR === '';
        //   obj['summaryKR_error'] = this.state.blog.summaryKR === '';
        //   obj['detailKR_error'] = this.state.blog.detailKR === '';
        //   obj['kr'] = obj['titleKR_error'] || obj['summaryKR_error'] || obj['detailKR_error'];
        //   this.setState({error:obj},function(){
        //     if(!$this.state.error[flag]) $this._save();
        //   });
        //   break;
        default:
          return true;
      }
    }
  }
  handleCancel() {
    this.context.router.history.push("/blog/");
  }
  handleChangeTab = (event, value) => {
    this.setState({ tab: value });
  };
  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  selectImg(value) {
    var $this = this,
      obj = this.state.blog;
    obj.thumb = value;
    this.setState({ blog: obj }, function() {
      $this.handleClose();
    });
  }
  handleChange(e) {
    var $this = this,
      obj = this.state.blog;
    obj.type = e.target.value;
    this.setState({ blog: obj });
  }
  handleTags(e) {
    var code = e.keyCode || e.which,
      blog = this.state.blog,
      tags = this.state.tags;
    if (code === 13) {
      var a_tags = e.target.value.split(","),
        trim_arr = [];
      for (var tag in a_tags) {
        let obj = { tag: a_tags[tag].trim(), appear: 1 };
        if(a_tags[tag].trim()!=='')trim_arr.push(a_tags[tag].trim());
        Utils._add("tag", obj, function(res) {});
      }
      var res = Utils.arrayUnique(blog.tags.concat(trim_arr));
      blog.tags = res;
      this.setState({ blog: blog, tags: res });
    }
  }
  choiceTags(e) {
    var blog = this.state.blog;
    blog.tags.push(e.target.value);
    this.setState({ blog: blog }, function() {});
  }
  handleDeleteTag(tag, index) {
    var blog = this.state.blog,
      tags = blog.tags,
      all_tags = this.state.tags;
    tags.splice(index, index + 1);
    blog.tags = tags;
    this.setState({ blog: blog }, function() {
      var _tag = all_tags.filter(x => {
        return x.tag === tag;
      });
      if (_tag.length) {
        _tag.appear = _tag.appear - 1;
        Utils._update("tag", _tag);
      }
    });
  }
  handleCopy() {
    var data = this.state.blog;
    data.titleEN = data.titleVN;
    data.subtitleEN = data.subtitleVN;
    data.summaryEN = data.summaryVN;
    data.detailEN = data.detailVN;
    data.descriptionEN = data.descriptionVN;
    this.setState({
      blog: data
    });
  }
  render() {
    const classes = this.props.classes;
    const value = this.state.tab;
    const blog = this.state.blog;
    const editorConfigBasic = Utils.setupBasicEditor();
    const editorConfig = Utils.setupEditor('blog',this.state.options);
    const tags = [];
    for (let i = 0, len = this.state.tags.length; i < len; i++) {
      let item = this.state.tags[i];
      let disabled = false;
      for (let y = 0, leny = blog.tags.length; y < leny; y++) {
        disabled = item.tag === blog.tags[y].trim();
        if (disabled) break;
      }
      tags.push(
        <option
          disabled={disabled}
          key={i + 1}
          data-id={item._id}
          data-appear={item.appear}
          value={item.tag}
        >
          {item.tag}
        </option>
      );
    }
    return (
      <div className="page-detail">
        <Toolbar className={classes.toolbar}>
          <Typography className={classes.heading} variant="h5">
            Thêm/Sửa bài viết (Blog)
          </Typography>
        </Toolbar>
        <AppBar position="static" className={classes.subToolbar}>
          <Tabs value={value} onChange={this.handleChangeTab}>
            <Tab label="Tiếng Việt" />
            <Tab label="English" />
            {/* <Tab label="한국인"/> */}
          </Tabs>
        </AppBar>
        {value === 0 && (
          <TabContainer>
            <form className={classes.form} noValidate>
              <Typography
                type="body2"
                className={classNames(
                  classes.error,
                  !this.state.error.vn && classes.hide
                )}
              >
                {language.VN.error.require}
              </Typography>
              <Typography
                type="body2"
                className={classNames(
                  classes.error,
                  !this.state.failed && classes.hide
                )}
              >
                {this.state.message}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                aria-label="copy"
                onClick={() => this.handleCopy()}
              >
                Copy to [EN]
              </Button>
              <FormGroup className={classes.formRow}>
                <FormControl>
                  <Typography className={classes.label} type="caption">
                    Nhóm blog
                  </Typography>
                  <Select
                    native
                    id="category"
                    value={blog.category}
                    onChange={event => this.handleFieldChange(event)}
                  >
                    <option key={0} value="">
                      ...
                    </option>
                    {this.state.categories.map((item, index) => (
                      <option key={index + 1} value={item._id}>
                        {item.nameVN}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </FormGroup>
              <TextField
                id="titleVN"
                label={language.VN.title}
                className={classes.textField}
                value={blog.titleVN}
                onChange={event => this.handleValidate(event, "vn")}
                onBlur={event => this.handleValidate(event, "vn")}
                required={true}
                error={this.state.error.titleVN_error}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="urlVN"
                label="Link [SEO]"
                className={classes.textField}
                value={blog.urlVN}
                disabled={true}
                onChange={event => this.handleFieldChange(event)}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="subtitleVN"
                label={language.VN.subTitle}
                className={classes.textField}
                value={blog.subtitleVN}
                onChange={event => this.handleFieldChange(event)}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <FormGroup className={classes.formRowInline}>
                <FormControl className={classes.col4}>
                  <TextField
                    className="form-control-no-bottom"
                    id="author"
                    label={language.VN.author}
                    value={blog.author}
                    onChange={event => this.handleFieldChange(event)}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </FormControl>
                <FormControl className={classes.col4}>
                  <TextField
                    id="date"
                    className="form-control-no-bottom"
                    label={language.VN.date}
                    value={Utils.formatDate(blog.date)}
                    type="date"
                    onChange={event => this.handleFieldChange(event)}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </FormControl>
                <FormControl className={classes.col4}>
                  <Typography className={classes.label}>Trạng thái</Typography>
                  <Select
                    native
                    className={classes.selectMultiLevel}
                    id="status"
                    value={blog.status}
                    onChange={event => this.handleFieldChange(event)}
                  >
                    <option value="" key={0}>
                      ...
                    </option>
                    {this.state.status.map((item, index) => {
                      return (
                        <option key={index + 1} value={index}>
                          {item}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
              <FormGroup className={classes.formRow}>
                <ImageControl
                  value={blog.thumb}
                  handleChange={value => this.handleImageChange(value)}
                />
              </FormGroup>
              <FormGroup className={classes.formRow}>
                <FormControl>
                  <Typography className={classes.label} type="caption">
                    Tags (Mỗi tag cách nhau dấu phẩy)
                  </Typography>
                  <TextField
                    id="tags"
                    className={classes.textField}
                    onKeyPress={event => this.handleTags(event)}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <Select
                    native
                    className={"select " + classes.select}
                    onChange={event => this.handleTags(event)}
                  >
                    <option value="" key={0}>
                      ...
                    </option>
                    {tags}
                  </Select>
                </FormControl>
              </FormGroup>
              <FormGroup className={classes.chipRow}>
                {blog.tags !== undefined &&
                  blog.tags !== null &&
                  blog.tags.map((item, index) => (
                    <Chip
                      label={item}
                      key={index}
                      onDelete={() => this.handleDeleteTag(item, index)}
                      className={classes.chip}
                    />
                  ))}
              </FormGroup>
              <TextField
                id="descriptionVN"
                rows="5"
                multiline={true}
                label="Meta Description (max. length: 200 characters)"
                className={classes.textField}
                value={blog.descriptionVN}
                onChange={event => this.handleFieldChange(event)}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <FormLabel
                className={classes.label_shrink}
                required={true}
                error={this.state.error.summaryVN_error}
              >
                {language.VN.summary}
              </FormLabel>
              <FroalaEditor
                tag="textarea"
                config={editorConfigBasic}
                model={blog.summaryVN}
                onModelChange={value =>
                  this.onEditorStateChange("summaryVN", value)
                }
              />
              <FormLabel
                className={classes.label_shrink}
                required={true}
                error={this.state.error.detailVN_error}
              >
                {language.VN.detail}
              </FormLabel>
              {
                this.state.options['empty']!=='empty' && (
                  <FroalaEditor
                    tag="textarea"
                    config={editorConfig}
                    model={blog.detailVN}
                    onModelChange={value =>
                      this.onEditorStateChange("detailVN", value)
                    }
                  />
                )
              }
              <FormGroup row className={classes.formRow}>
                <Button
                  color="default"
                  onClick={event => this.handleCancel(event)}
                >
                  {language.VN.btnCancel}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={event => this.handleSave(event, "vn")}
                >
                  {language.VN.btnSave}
                </Button>
              </FormGroup>
            </form>
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer>
            <form className={classes.form} noValidate>
              <Typography
                type="body2"
                className={classNames(
                  classes.error,
                  !this.state.error.en && classes.hide
                )}
              >
                {language.EN.error.require}
              </Typography>
              <Typography
                type="body2"
                className={classNames(
                  classes.error,
                  !this.state.failed && classes.hide
                )}
              >
                {this.state.message}
              </Typography>
              <TextField
                id="titleEN"
                label={language.EN.title}
                className={classes.textField}
                value={this.state.blog.titleEN}
                onChange={event => this.handleValidate(event, "en")}
                onBlur={event => this.handleValidate(event, "en")}
                required={true}
                error={this.state.error.titleEN_error}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="urlEN"
                label="Link [SEO]"
                className={classes.textField}
                value={blog.urlEN}
                disabled={true}
                onChange={event => this.handleFieldChange(event)}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="subtitleEN"
                label={language.EN.subTitle}
                className={classes.textField}
                value={this.state.blog.subtitleEN}
                onChange={event => this.handleFieldChange(event)}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="descriptionEN"
                rows="5"
                multiline={true}
                label="Meta Description (max. length: 200 characters)"
                className={classes.textField}
                value={blog.descriptionEN}
                onChange={event => this.handleFieldChange(event)}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <FormLabel
                className={classes.label_shrink}
                required={true}
                error={this.state.error.summaryEN_error}
              >
                {language.EN.summary}
              </FormLabel>
              <FroalaEditor
                tag="textarea"
                config={editorConfigBasic}
                model={blog.summaryEN}
                onModelChange={value =>
                  this.onEditorStateChange("summaryEN", value)
                }
              />
              <FormLabel
                className={classes.label_shrink}
                required={true}
                error={this.state.error.detailEN_error}
              >
                {language.EN.detail}
              </FormLabel>
              {
                this.state.options['empty']!=='empty' && (
                  <FroalaEditor
                    tag="textarea"
                    config={editorConfig}
                    model={blog.detailEN}
                    onModelChange={value =>
                      this.onEditorStateChange("detailEN", value)
                    }
                  />
                )
              }
              <FormGroup row className={classes.formRow}>
                <Button
                  color="default"
                  onClick={event => this.handleCancel(event)}
                >
                  {language.EN.btnCancel}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={event => this.handleSave(event, "en")}
                >
                  {language.EN.btnSave}
                </Button>
              </FormGroup>
            </form>
          </TabContainer>
        )}
        {/* {value === 2 && <TabContainer>
          <form className={classes.form} noValidate>
            <Typography type="body2" className={classNames(classes.error, !this.state.error.kr && classes.hide)}>{language.KR.error.require}</Typography>
            <Typography type="body2" className={classNames(classes.error, !this.state.failed && classes.hide)}>{this.state.message}</Typography>
            <TextField id="titleKR" label={language.KR.title} className={classes.textField} value={blog.titleKR} onChange={(event) => this.handleValidate(event,'kr')} onBlur={(event) => this.handleValidate(event,'kr')} required={true} error={this.state.error.titleKR_error} margin="normal" InputLabelProps={{
              shrink: true
            }}/>
            <TextField id="subtitleKR" label={language.KR.subTitle} className={classes.textField} value={blog.subtitleKR} onChange={(event) => this.handleFieldChange(event)} margin="normal" InputLabelProps={{
              shrink: true
            }}/>
            <TextField id="descriptionKR" rows="5" multiline={true} label="Meta Description (max. length: 200 characters)" className={classes.textField} value={blog.descriptionKR} onChange={(event) => this.handleFieldChange(event)} margin="normal" InputLabelProps={{
              shrink: true
            }}/>
            <FormLabel className={classes.label_shrink} required={true} error={this.state.error.summaryKR_error}>{language.KR.summary}</FormLabel>
            <FroalaEditor
              tag='textarea'
              config={editorConfigBasic}
              model={this.state.blog.summaryKR}
              onModelChange={(value)=>this.onEditorStateChange('summaryKR',value)}
            />
            <FormLabel className={classes.label_shrink} required={true} error={this.state.error.detailKR_error}>{language.KR.detail}</FormLabel>
            <FroalaEditor
              tag='textarea'
              config={editorConfig}
              model={this.state.blog.detailKR}
              onModelChange={(value)=>this.onEditorStateChange('detailKR',value)}
            />
            <FormGroup row className={classes.formRow}>
              <Button color="default" onClick={(event) => this.handleCancel(event)}>{language.KR.btnCancel}</Button>
              <Button variant="contained" color="primary" onClick={(event) => this.handleSave(event,'kr')}>{language.KR.btnSave}</Button>
            </FormGroup>
          </form>
        </TabContainer>} */}
        {/* <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <div className={classes.dialogMedia}>
            <FormGroup row className={classes.formRow}>
              <Button color="default" onClick={this.handleClose}>
                {language.VN.btnCancel}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleSelect}
              >
                {language.VN.btnSave}
              </Button>
            </FormGroup>
            <Media onSelectChange={value => this.selectImg(value)} />
          </div>
        </Dialog> */}
      </div>
    );
  }
}

BlogDetail.propTypes = {
  classes: PropTypes.object.isRequired
};
BlogDetail.contextTypes = {
  router: PropTypes.object
};

export default withStyles(styles)(BlogDetail);
